module.exports = __webpack_public_path__ + "img/38.58f86aed.png";